// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"container___1gXBu","upcoming-wrapper":"upcoming-wrapper___VAh4B","grid":"grid___1-fb6","watch-wrapper":"watch-wrapper___25nGI","watch":"watch___1ITYt"};